export default __webpack_public_path__ + "static/media/ImgGear.d0523bc4.jpg";